// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `input, textarea {
   cursor: unset;
}

:host ::ng-deep .mat-radio-button.mat-radio-checked.mat-accent.cdk-focused .mat-radio-ripple .mat-ripple-element {
   width: 25px !important;
   height: 25px !important;
   border-radius: 50%;
   margin-left: 7px;
   margin-top: 9.5px;
}

:host ::ng-deep .mat-radio-button.mat-accent.cdk-focused .mat-radio-ripple .mat-ripple-element {
   width: 25px !important;
   height: 25px !important;
   border-radius: 50%;
   margin-left: 7px;
   margin-top: 9.5px;
}

.txt-field-body {
   border-style: none;
   overflow: hidden;
}
.inline {
   float: left;
}

.field-container {
   display: flex;
   flex-direction: column;
}

.choice-field-body {
   border-style: none;
}

.choice-layout-0, .choice-field-body .choice-layout-1 {
   margin: 2px 10px 6px 12px !important;
}

.c-validation {
   font-weight: normal;
   font-size: 0.8125em;
   line-height: 1.3em;
   margin-top: -8px;
   margin-left: 12px;
   margin-right: 10px;
   color: red;
}
`, "",{"version":3,"sources":["webpack://./src/app/e-form/form-generate/field-type/radio/radio.component.css"],"names":[],"mappings":"AAAA;GACG,aAAa;AAChB;;AAEA;GACG,sBAAsB;GACtB,uBAAuB;GACvB,kBAAkB;GAClB,gBAAgB;GAChB,iBAAiB;AACpB;;AAEA;GACG,sBAAsB;GACtB,uBAAuB;GACvB,kBAAkB;GAClB,gBAAgB;GAChB,iBAAiB;AACpB;;AAEA;GACG,kBAAkB;GAClB,gBAAgB;AACnB;AACA;GACG,WAAW;AACd;;AAEA;GACG,aAAa;GACb,sBAAsB;AACzB;;AAEA;GACG,kBAAkB;AACrB;;AAEA;GACG,oCAAoC;AACvC;;AAEA;GACG,mBAAmB;GACnB,mBAAmB;GACnB,kBAAkB;GAClB,gBAAgB;GAChB,iBAAiB;GACjB,kBAAkB;GAClB,UAAU;AACb","sourcesContent":["input, textarea {\n   cursor: unset;\n}\n\n:host ::ng-deep .mat-radio-button.mat-radio-checked.mat-accent.cdk-focused .mat-radio-ripple .mat-ripple-element {\n   width: 25px !important;\n   height: 25px !important;\n   border-radius: 50%;\n   margin-left: 7px;\n   margin-top: 9.5px;\n}\n\n:host ::ng-deep .mat-radio-button.mat-accent.cdk-focused .mat-radio-ripple .mat-ripple-element {\n   width: 25px !important;\n   height: 25px !important;\n   border-radius: 50%;\n   margin-left: 7px;\n   margin-top: 9.5px;\n}\n\n.txt-field-body {\n   border-style: none;\n   overflow: hidden;\n}\n.inline {\n   float: left;\n}\n\n.field-container {\n   display: flex;\n   flex-direction: column;\n}\n\n.choice-field-body {\n   border-style: none;\n}\n\n.choice-layout-0, .choice-field-body .choice-layout-1 {\n   margin: 2px 10px 6px 12px !important;\n}\n\n.c-validation {\n   font-weight: normal;\n   font-size: 0.8125em;\n   line-height: 1.3em;\n   margin-top: -8px;\n   margin-left: 12px;\n   margin-right: 10px;\n   color: red;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
